import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

const Root = styled.div`
  margin-block-end: 24px;
  color: ${cbSemanticCssVars.textPrimary};
`;

const PEPInfo = () => (
  <Root>
    <T.Body2>
      <ul>
        <li>
          <FormattedMessage id="compliance.kyb.sections.beneficiaries.politically-exposed-persons.bullets.heads-of-state" />
        </li>
        <li>
          <FormattedMessage id="compliance.kyb.sections.beneficiaries.politically-exposed-persons.bullets.politicians" />
        </li>
        <li>
          <FormattedMessage id="compliance.kyb.sections.beneficiaries.politically-exposed-persons.bullets.officials" />
        </li>
        <li>
          <FormattedMessage id="compliance.kyb.sections.beneficiaries.politically-exposed-persons.bullets.judiciary-military" />
        </li>
        <li>
          <FormattedMessage id="compliance.kyb.sections.beneficiaries.politically-exposed-persons.bullets.executives" />
        </li>
        <li>
          <FormattedMessage id="compliance.kyb.sections.beneficiaries.politically-exposed-persons.bullets.other" />
        </li>
      </ul>
    </T.Body2>
  </Root>
);

export default PEPInfo;
